export default {
    login: {
        title: "ចូលគណនី",
        username: "ឈ្មោះគណនី | Username",
        password: "លេខសម្ងាត់ | Password",
        remember: "ចងចាំគណនី | remember me",
        submit: "ចូល",
        register: "ចុះឈ្មោះ",
        registerTitle: "ចុះឈ្មោះគណនី",
        confirmPassword: "បញ្ជាក់លេខសម្ងាត់",
        currency: "រូបិយប័ណ្ណ",
        submitRegister: "ចុះឈ្មោះ",
        needInputRegister: "សូមបំពេញព័ត៌មានទាំងអស់",
        backToLogin: "ត្រឡប់ទៅចូល",
        passwordNotMatch: "លេខសម្ងាត់មិនដូចគ្នា",
        registerFailed: "ចុះឈ្មោះបរាជ័យ",
        checkFailed: "ពិនិត្យឈ្មោះគណនីបរាជ័យ",
        needInput: "សូមបញ្ចូលឈ្មោះគណនី និងលេខសម្ងាត់"
    },
    common: {
        welcome: "សូមស្វាគមន៍",
        logout: "ចាកចេញ",
        lang_en: "English",
        lang_zh: "中文",
        lang_km: "ខ្មែរ"
    },
    menu: {
        news: "ដំណឹង",
        lotto: "ឡូតូ",
        lottery: "ឆ្នោត",
        balance: "តុល្យភាព",
        report: "របាយការណ៍",
        changePassword: "លេខសម្ងាត់"
    },
    sub: {
        lotto: "ឡូតូ",
        winResult: "របាយការណ៏នៃការឈ្នះ",
        winResultV1: "របាយការណ៏នៃការឈ្នះ 1",
        result: "លទ្ធផល"
    },
    left: {
        balances: "ចំនួនទឹកប្រាក់",
        outstanding: "ទឺកប្រាក់ភ្នាល់",
        lastResult: "លទ្ធផលចុងក្រោយ",
        currentTicket: "បុងកំពុងភ្នាល់",
        previousTicket: "បុងភ្នាល់រួចរាល់"
    },

    lotto: {
        over: "ធំ",            // O
        under: "តូច",          // U
        underover: "តូច/ធំ",
        total: "សរុប",
        qian: "១ពាន់",
        liangqian: "២ពាន់",
        wuqian: "៥ពាន់",
        wan: "១មុឺន",
        liangwan: "២មុឺន",
        wuwan: "៥មុឺន",
        ershiwan: "២០មុឺន",
        wushiwan: "៥០មុឺន",
        LimitBetting: "ដែនកំណត់លុយភ្នាល់",
        MaxPayout: "ការទូទាត់អតិបរមា",
        Stake: "ភ្នាល់",
        BET: "ចាក់",
        CANCEL: "លុបចោល",
        RESET: "សារដេីម",
        rangeTitle: "ចន្លោះលេខ",
        bettingClosed10Seconds: "ការភ្នាល់បានបិទក្នុងរយៈពេល 10 វិនាទីចុងក្រោយ។"
    },
    report: {
        No: "No",
        Date: "Date",
        Remark: "Remark",
        Turnover: "Turnover",
        ValidBet: "Valid Bet",
        NetWL: "Net W/L",
        Comm: "Comm",
        Deposit: "Deposit",
        Withdraw: "Withdraw",
        Balance: "Balance",
        Return: "Return",
        Info: "Info",
        Bet: "Bet",
        Result: "Result",
        Stack: "Stack",
        Status: "Status",
        Winlose: "Winlose"
    },
    result: {
        No: "No",
        Date: "Date",
        GetResult: "Get Result",
        Today: "Today",
        Yesterday: "Yesterday",
        Title: "Title",
        Result: "Result",
        Detail: "Detail",
        Bonus: "Bonus",
        UnderOver: "Under/Over",
        Range: "Range",
        clear: "Clear",
        weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
    },
    Balance: {
        AccountInfo: "Account Info",
        Account: "Account",
        UserName: "User Name",
        Lastlogintime: "Last login time",
        LastloginIP: "Last login IP",
        CreditInfo: "Credit Info",
        Currency: "Currency",
        CashBalance: "Cash Balance",
        Outstanding: "Outstanding",
        GivenCredit: "Given Credit",
        BetCredit: "Bet Credit"
    },
    Changepassword: {
        Changeyourpassword: "Change your password",
        OldPassword: "Old Password",
        NewPassword: "New Password",
        ConfirmPassword: "Confirm Password",
        Confirm: "Confirm",
        Clear: "Clear",
        Note: "Note",
        Note1: "New password can not be as same as the login ID;",
        Note2: "New password should be composed by 1 letter and 1 digit at least, and should not less than 6 bits.",
        Note3: "New password can not be too simple, such as aaaa1111."
    },
    footer: {
        footer: "© Copyright 2026 LOTTO8888, All rights reserved"

    },
    print: {
        issue: "លេខសំបុត្រ",
        ticketId: "លេខសម្គាល់",
        time: "ថ្ងៃទី",
        betType: "ប្រភេទភ្នាល់",
        coef: "មេគុណ",
        winlose: "ឈ្នះ ចាញ់",
    }
};
